import { SettingService } from './../../../shared/services/setting.service';
import { CommonService } from './../../../shared/services/common.service';
import { ProfileContactService } from './../../../shared/services/profile-contact.service';
import { ISetting } from './../../../_models/cms/ISetting';
import { IKeyValuePair } from './../../../_models/common/common';
import { IProfileContact } from './../../../_models/account/IProfile';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-profile-contact-form',
  templateUrl: './profile-contact-form.component.html'
})
export class ProfileContactFormComponent implements OnInit {
  loading: boolean;
  skeleton: boolean = true;
  title: string = 'Add Contact Details';
  profileContact: IProfileContact;
  profileContactForm: FormGroup;
  id;

  religions: IKeyValuePair[];
  genders: IKeyValuePair[];
  regions: IKeyValuePair[];
  categories: IKeyValuePair[];
  states: IKeyValuePair[];
  homeDistricts: IKeyValuePair[];
  presentDistricts: IKeyValuePair[];
  permanentDistricts: IKeyValuePair[];

  setting: ISetting;
  constructor(private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private service: ProfileContactService,
    private commonService: CommonService,
    private settingService: SettingService) {
  }

  async ngOnInit() {

    this.setting = await this.settingService.getSetting();
    if (this.setting && !this.setting.isProfile) {
      this.toastrService.warning("profile module closed!");
      this.router.navigate(['/employee']);
      return;
    }


    this.createProfileContactForm();
    this.setProfileContactValidators();
    this.bindDropDown();
    this.service.logged().subscribe((response: IProfileContact) => {
      if (response) {
        this.profileContact = response;
        this.title = 'Edit Contact Details';
        this.id = response.userId;
        this.setValueProfileForm();
      }
    },
      (error) => console.log('HTTP Error', error),
      () => this.skeleton = false);
  }

  bindDropDown() {

    this.commonService.getStates().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.states = response;
      }
    });
  }

  getPresentDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.presentDistricts = response;
      }
    });
  }

  getPermanentDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.permanentDistricts = response;
      }
    });
  }

  setProfileContactValidators() {
    const permanentAddressControl = this.profileContactForm.get('permanentAddress');
    const permanentCityControl = this.profileContactForm.get('permanentCity');
    const permanentPincodeControl = this.profileContactForm.get('permanentPincode');
    const permanentStateIdControl = this.profileContactForm.get('permanentStateId');
    const permanentDistrictIdControl = this.profileContactForm.get('permanentDistrictId');

    this.profileContactForm.get('isPermanentSame').valueChanges
      .subscribe(isPermanentSame => {

        if (!isPermanentSame) {
          permanentAddressControl.setValidators([Validators.required]);
          permanentCityControl.setValidators([Validators.required]);
          permanentPincodeControl.setValidators([Validators.required]);
          permanentStateIdControl.setValidators([Validators.required]);
          permanentDistrictIdControl.setValidators([Validators.required]);
        }
        else {
          permanentAddressControl.setValidators(null);
          permanentCityControl.setValidators(null);
          permanentPincodeControl.setValidators(null);
          permanentStateIdControl.setValidators(null);
          permanentDistrictIdControl.setValidators(null);
        }

        permanentAddressControl.updateValueAndValidity();
        permanentCityControl.updateValueAndValidity();
        permanentPincodeControl.updateValueAndValidity();
        permanentStateIdControl.updateValueAndValidity();
        permanentDistrictIdControl.updateValueAndValidity();
      });
  }

  createProfileContactForm() {
    this.profileContactForm = this.fb.group({
      userId: [''],
      presentAddress: ['', Validators.required],
      presentCity: ['', Validators.required],
      presentPincode: ['', Validators.required],
      presentStateId: ['', Validators.required],
      presentDistrictId: ['', Validators.required],
      isPermanentSame: [false, Validators.required],
      permanentAddress: [''],
      permanentCity: [''],
      permanentPincode: [''],
      permanentStateId: [''],
      permanentDistrictId: [''],
      isActive: [true, Validators.required]
    });
  }

  setValueProfileForm() {

    if (this.profileContact.presentStateId) {
      this.getPresentDistricts(this.profileContact.presentStateId);
    }

    if (this.profileContact.permanentStateId) {
      this.getPermanentDistricts(this.profileContact.permanentStateId);
    }

    this.profileContactForm.patchValue({
      userId: this.profileContact.userId,
      presentAddress: this.profileContact.presentAddress,
      presentCity: this.profileContact.presentCity,
      presentPincode: this.profileContact.presentPincode,
      presentStateId: this.profileContact.presentStateId,
      presentDistrictId: this.profileContact.presentDistrictId,
      isPermanentSame: this.profileContact.isPermanentSame,
      permanentAddress: this.profileContact.permanentAddress,
      permanentCity: this.profileContact.permanentCity,
      permanentPincode: this.profileContact.permanentPincode,
      permanentStateId: this.profileContact.permanentStateId,
      permanentDistrictId: this.profileContact.permanentDistrictId,
      isActive: this.profileContact.isActive
    });
  }

  save() {
    if (this.profileContactForm.valid) {
      this.loading = true;
      this.profileContact = Object.assign({}, this.profileContactForm.value);
      if (this.id) {
        this.service.update(this.id, this.profileContact).subscribe(() => {
          this.toastrService.success('contact details updated successful');
          this.router.navigate(['/employee/profile/thumb']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.profileContact).subscribe(() => {
          this.toastrService.success('contact details saved successful');
          this.router.navigate(['/employee/profile/thumb']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }

}
